module.exports = __webpack_public_path__ + "static/media/monthly_discussion.fd8ae2ac.jpg";